import { Button, Form, Input, Modal, Table, Tag } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getOvertimeByUser } from "../../redux/rtk/features/overtime/overtimeSlice";
import getUserFromToken from "../../utils/getUserFromToken";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

function UserOvertimeData() {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.overtime);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [form] = Form.useForm();

    console.log("list", list);
    const userId = getUserFromToken();
    useEffect(() => {
        if (userId) {
            dispatch(getOvertimeByUser(userId));
        }
    }, [dispatch, userId]);

    const formatOvertimeLength = (length) => {
        const hours = Math.floor(length);
        const minutes = Math.round((length - hours) * 60);
        return `${hours}h ${minutes}m`;
    };

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            title: "Employee Name",
            dataIndex: "user",
            key: "user",
            render: (user) => `${user.firstName} ${user.lastName}`,
        },
        {
            title: "Overtime Start",
            dataIndex: "overtimeStart",
            key: "overtimeStart",
            render: (overtimeStart) => dayjs(overtimeStart).utc().format("DD-MM-YYYY, HH:mm"),
        },
        {
            title: "Overtime End",
            dataIndex: "overtimeEnd",
            key: "overtimeEnd",
            render: (overtimeEnd) => dayjs(overtimeEnd).utc().format("DD-MM-YYYY, HH:mm"),
        },
        {
            title: "Overtime Length",
            dataIndex: "overtimeLength",
            key: "overtimeLength",
            render: (overtimeLength) => formatOvertimeLength(overtimeLength),
        },
        {
            title: "Reward",
            dataIndex: "overtimeReward",
            key: "overtimeReward",
            render: (overtimeReward) => (overtimeReward === false ? "TOIL" : "Payable"),
        },
        {
            title: "Remarks",
            dataIndex: "note",
            key: "note",
            render:(text)=>{
                return text ? text: "N/A"
            }
        },
        {
            title: "Approval Status",
            dataIndex: "approve",
            key: "approve",
            render: (approve) => {
                let statusText;
                let color;

                if (approve === 1) {
                    statusText = "Accepted";
                    color = "green";
                } else if (approve === 0) {
                    statusText = "Rejected";
                    color = "red";
                } else {
                    statusText = "Pending";
                    color = "orange";
                }

                return <span style={{ color }}>{statusText}</span>;
            },
        },
        {
        	id: 8,
        	title: "Payment Status",
        	dataIndex: "paymentStatus",
        	key: "paymentStatus",
        	render: (paymentStatus) => {
        		if (paymentStatus === "PAID") {
        			return <Tag color='green'>{paymentStatus.toUpperCase()}</Tag>;
        		} else {
        			return <Tag color='orange'>{(paymentStatus || "UNPAID").toUpperCase()}</Tag>;
        		}
        	},
        },
    ];

    const handleAction = (record) => {
        setSelectedRecord(record);
        form.setFieldsValue({
            user: `${record.user.firstName} ${record.user.lastName}`,
            overtimeHours: record.overtimeLength, // or correct property if needed
            overtimeStatus: record.status ? "Approved" : "Pending", // Adjust if you have a specific status format
        });
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
        form.resetFields();
    };

    const handleModalSubmit = async () => {
        try {
            const values = await form.validateFields();
            // Submit logic (e.g., update data via an API call)
            toast.success("Overtime data updated successfully!");
            setIsModalVisible(false);
            form.resetFields();
        } catch (info) {
            console.error("Validation Failed:", info);
        }
    };

    return (
        <div>
            {/* <h2>Overtime Data</h2> */}
            {/* <Table
                columns={columns}
                dataSource={list.map((item, index) => ({ ...item, serial: index + 1 }))}
                loading={loading}
                rowKey="id"
            /> */}
            <Table
    columns={columns}
    dataSource={(list ?? []).map((item, index) => ({ ...item, serial: index + 1 }))}
    loading={loading}
    rowKey="id"
/>

            <Modal
                title="Overtime Details"
                visible={isModalVisible}
                onCancel={handleModalCancel}
                footer={[
                    <Button key="cancel" onClick={handleModalCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleModalSubmit}>
                        Submit
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Employee Name"
                        name="user"
                        rules={[{ required: true, message: "Employee Name is required" }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Overtime Hours"
                        name="overtimeHours"
                        rules={[{ required: true, message: "Overtime Hours is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Overtime Status"
                        name="overtimeStatus"
                        rules={[{ required: true, message: "Overtime Status is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default UserOvertimeData;
